import { type ActionEvent, Controller } from "@hotwired/stimulus"

import CounterController from "@/controllers/counter_controller"
import { pluralize } from "@/helpers/pluralize"

const LARGE_GROUP_THRESHOLD = 8

export default class extends Controller {
  static outlets = ["guests-counter"]
  declare readonly guestsCounterOutlet: CounterController

  static targets = ["groupsLink", "resetButton"]
  declare readonly groupsLinkTarget: HTMLAnchorElement
  declare readonly resetButtonTarget: HTMLButtonElement
  declare readonly hasResetButtonTarget: boolean

  get isZeroSelected(): boolean {
    return this.guestsCounterOutlet.countValue === 0
  }

  resetGuests(): void {
    this.guestsCounterOutlet.setCountTo(0)
  }

  resetIfEmpty({ currentTarget }: ActionEvent): void {
    if (!(currentTarget as HTMLInputElement).value) {
      this.resetGuests()
    }
  }

  get summaryText(): string {
    return this.isZeroSelected
      ? "Any"
      : pluralize(this.guestsCounterOutlet.countValue, "person", "people")
  }

  onCountChange(): void {
    const { countInputTarget, countValue } = this.guestsCounterOutlet

    // Disable guests counter input if zero so it's not submitted.
    countInputTarget.disabled = countValue === 0
    this.groupsLinkTarget.hidden = countValue < LARGE_GROUP_THRESHOLD
    this.resetButtonTarget.hidden = countValue === 0
  }
}
